import React, { Component, PropTypes } from 'react';
import { Link } from 'react-router';
import { connect } from 'react-redux';
import { SparkMenu } from '../../ui/spark';
import LeftMainmenuItem from '../../helpers/LeftMainmenuItem';
import AppMenuConfig from '../../../config/Menu';
import { checkPermissionForLevel, checkPermissions } from '../../../../lib/utils';
import { ACCESS_POINTS_GROUP, ACCESS_POINT_LEVEL } from '../../../constants/AccessPoints';

class NavigationTheme extends Component {
    componentDidMount() {
        this.menuInstance = new SparkMenu(this.node);
    }

    isLinkDisabled(elem) {
        if (elem.link === 'customContent') {
            return !this.props.hasAccessToCustomContent.view && !this.props.hasAccessToCustomContent.edit;
        }

        return !(_.get(elem, 'force', false) || this.props.hasAccess.view || this.props.hasAccess.edit);
    }

    render() {
        const menuItems = [
            {
                title: 'Global Styles',
                elements: AppMenuConfig.theme.global
            },
            {
                title: 'Components',
                elements: AppMenuConfig.theme.components
            }
        ];

        return (
            <div className="NavigationTheme">
                <div className="container">
                    <Link to="/">
                        <div className="row">
                            <div className="col-md-2">
                                <i style={{ marginTop: 6 }} className="spark-icon-arrow-basic-left spark-icon--xd" />
                            </div>
                            <div className="col-md-10 link-to-home">Home</div>
                        </div>
                    </Link>
                </div>
                <LeftMainmenuItem icon="spark-icon-design-palette" title="Theme" copy="" />
                <div className="spark-panel__content leftnav-menu-submenu-container">
                    <nav
                        ref={node => (this.node = node)}
                        className="spark-menu spark-menu--panel col-xs-12 col-col-md-12 col-lg-12 col-xl-12"
                    >
                        {menuItems.map((menuItem, idx) => {
                            return (
                                <ul className="spark-menu__list" key={`sparkList${idx}`}>
                                    <li style={{ fontSize: '15px' }} className="spark-menu__list-title">
                                        {menuItem.title}
                                    </li>
                                    {menuItem.elements.map((elem, idx) => {
                                        // workaround as the Spark FW sets a className "active" on the <li> elem
                                        const active = `/theme/${elem.link}` === this.props.location.pathname;
                                        const cssClassName = active
                                            ? 'spark-menu__list-item active'
                                            : 'spark-menu__list-item';

                                        return (
                                            <li
                                                key={`item${idx}`}
                                                className={`${
                                                    this.isLinkDisabled(elem) ? 'disabled-link' : ''
                                                } ${cssClassName}`}
                                            >
                                                <Link
                                                    disabled={this.isLinkDisabled(elem)}
                                                    to={`/theme/${elem.link}`}
                                                    activeClassName="active"
                                                    className="spark-menu__list-link"
                                                >
                                                    {elem.name}
                                                </Link>
                                            </li>
                                        );
                                    })}
                                </ul>
                            );
                        })}
                    </nav>
                </div>
            </div>
        );
    }
}

NavigationTheme.propTypes = {
    location: PropTypes.object,
    hasAccess: PropTypes.object
};

const mapStateToProps = state => {
    return {
        hasAccess: checkPermissions(state, ACCESS_POINTS_GROUP.THEMES),
        hasAccessToCustomContent: checkPermissions(state, ACCESS_POINTS_GROUP.CUSTOM_CONTENT)
    };
};

export default connect(mapStateToProps)(NavigationTheme);



// WEBPACK FOOTER //
// ./src/components/pages/theme/NavigationTheme.js